// 回る順番のおすすめの表示（仕様書「回る順番のおすすめ」）
import type { RoutePlan } from '@torapon/shared';

const hm = (iso: string) => { const d = new Date(iso); return `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`; };
const PATTERN_HINT = (p: string) => (/^P+D+$/.test(p) ? 'まとめて積んでから届ける' : /^(PD)+$/.test(p) ? '積んでは届ける' : '積む・届けるを組み合わせる');

export function RoutePlanBox({ plan, onApply, applyLabel = 'おすすめの順にする' }: { plan: RoutePlan; onApply?: () => void; applyLabel?: string }) {
  const r = plan.recommended, c = plan.current;
  const end = (s: typeof r) => (s.etas.length ? hm(s.etas[s.etas.length - 1]!.arriveAt) : '—');
  return (
    <section aria-label="回る順番のおすすめ" style={{ border: '1px solid var(--line)', borderRadius: 12, padding: 12, display: 'grid', gap: 6 }}>
      {plan.gainMin > 0 ? <>
        <b>おすすめ：{r.pattern}（{PATTERN_HINT(r.pattern)}）</b>
        <span style={{ fontSize: 13 }}>今の順（{c.pattern}）より約 {plan.gainMin} 分早く回れる見込み。移動 約 {r.driveMin} 分・全体 約 {r.totalMin} 分{r.lateMin ? <b className="err">・必着に約 {r.lateMin} 分遅れる</b> : '・必着に間に合う'}</span>
        {c.lateMin > 0 && <span className="err" style={{ fontSize: 13 }}>今の順だと必着に約 {c.lateMin} 分遅れる見込みです</span>}
        {onApply && <button className="btn sm pri" style={{ justifySelf: 'start' }} onClick={onApply}>{applyLabel}</button>}
      </> : <>
        <b>今の順（{c.pattern}）がいちばん早い見込みです</b>
        <span style={{ fontSize: 13 }}>移動 約 {c.driveMin} 分・全体 約 {c.totalMin} 分（回り終わり {end(c)} ごろ）{c.lateMin ? <b className="err">・必着に約 {c.lateMin} 分遅れる</b> : ''}</span>
      </>}
      <small className="muted">移動時間は道のりの目安と時間帯ごとの速さ（{plan.learned ? 'この事務所の走った記録' : 'まだ記録が少ないので決まりの値'}）から見積もっています{plan.fromHere ? '。今いる場所から数えています' : ''}。渋滞の情報は地図のキーをつないでから使います</small>
    </section>
  );
}
